import styles from './products-skus-attribute-groups.module.scss'
import { observer } from 'mobx-react-lite'
import { H2, Button, Text2, NoneLabel, IconExpand } from '@touche-lts/panel-ui/dist'
import { useRootStore } from 'mobx-stores/store-provider'
import { IconEdit, IconInfoSmall } from 'assets/icons'
import { ProductAttributeGroup } from './product-sku-attribute-group'

const ProductsSKUsAttributeGroupComponent = (props) => { // TODO-A To put a model here
    const { productId, productSKU } = props
    const {
        productsSKUsStore: {
            haveAttributeGroups,
            productSKUsAttributeStore,
            editMode,
            onCancelEditClick,
            onEditButtonClick,
            updateProductSKUAttributes,
            onAddAttributeGroupClick,
            openDialogSKUs
        },
        productsSKUTableStore: {
          skuTableElementsLength
        }
    } = useRootStore()

  return (
    <div className='pt-3'>
      <H2 colorPreset='dark' className={styles.heading}>
        Attributes{' '}
        {editMode ? (
          <div className={styles.headingButtonsContainer}>
            <Button
              preset='secondary'
              colorPreset='dark'
              onClick={onCancelEditClick}
            >
              Discard
            </Button>
            <Button preset='primary' onClick={() => updateProductSKUAttributes(productId)}>
                {skuTableElementsLength > 1 ? 'Apply changes' : 'Generate SKUs'}
            </Button>
          </div>
        ) : (
          <Button preset='icon' onClick={onEditButtonClick}>
            <IconEdit fill={styles.white} />
          </Button>
        )}
      </H2>
      {haveAttributeGroups ? (
        <div>
          {editMode && (
            <div className={styles.attributeLineChildren}>
              <Text2
                colorPreset='dark'
                bold
                className={styles.labelWithInfoIcon}
              >
                Attribute
                <IconInfoSmall title='Some info about Attribute' />
              </Text2>
              <Text2 colorPreset='dark' bold>
                Type
              </Text2>
              <Text2
                colorPreset='dark'
                bold
                className={styles.labelWithInfoIcon}
              >
                Values
                <IconInfoSmall title='Some info about Value' />
              </Text2>
            </div>
          )}
          {productSKUsAttributeStore.map(attributeGroup => {
            return (
                <ProductAttributeGroup 
                    key={attributeGroup.id}
                    attributeGroup={attributeGroup}                
                />
            )
          })}
        </div>
      ) : (
        <NoneLabel colorPreset='dark' label='No attributes added yet' />
      )}

      <Button
        preset='link'
        style={{ marginTop: 30 }}
        onClick={onAddAttributeGroupClick}
      >
        <IconExpand style={{ marginRight: 8, fill: styles.primary }} />
        Add{haveAttributeGroups && ' another'} attribute
      </Button>
      
      {skuTableElementsLength <= 1 && !editMode && (
        <Button
        preset='primary'
        className='mt-3'
        onClick={() => openDialogSKUs(productId, productSKU)}
      >
        Generate SKUs
      </Button>
      )}
    </div>
  )
}

const ProductsSKUsAttributeProduct = observer(ProductsSKUsAttributeGroupComponent)
export { ProductsSKUsAttributeProduct }
